export default {
  business: {
    sid: '',
    name: '',
    timezone: '',
    phone: '',
    phoneCC: '',
    billSameAsPrimary: true,
    primaryAddress: {
      street: '',
      city: '',
      state: '',
      postalCode: ''
    }
  },
  devices: [],
  deviceTypes: []
}
